import _objectSpread from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/empty.png';
import _imports_1 from '@/assets/more.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d44038d0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  "class": "container"
};
var _hoisted_2 = {
  "class": "banner"
};
var _hoisted_3 = {
  "class": "banner-item"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "empty"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_7 = {
  key: 0,
  "class": "wrapper"
};
var _hoisted_8 = {
  "class": "banner"
};
var _hoisted_9 = {
  "class": "banner-item"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  "class": "title"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  "class": "text"
};
var _hoisted_14 = {
  "class": "dt"
};
var _hoisted_15 = {
  "class": "dd"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1
  }, null, -1);
});
import Activity from '@/common/components/Activity.vue';
import { computed } from 'vue';
import { ScreenScrollView, useScrollView } from '@/common/components/ScreenScroll';
import { postApiFeedbackList } from '@/service/api';
import { useNavigation } from '@/common/util/navigation';
import default_avatar from '@/assets/default_avatar.png';
import { t } from '@/i18n';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _window = window,
      nickname = _window.nickname,
      avatar = _window.avatar;
    var _useNavigation = useNavigation(),
      toNext = _useNavigation.toNext;
    var _useScrollView = useScrollView({
        initPageSize: 10,
        api: function api(model) {
          return postApiFeedbackList(_objectSpread(_objectSpread({}, model), {}, {
            appId: window.appId,
            openId: window.openid
          }));
        }
      }),
      model = _useScrollView.model,
      list = _useScrollView.list,
      method = _useScrollView.method,
      loading = _useScrollView.loading,
      refreshing = _useScrollView.refreshing,
      error = _useScrollView.error;
    // const {model, list, method, loading, refreshing, error} = useScrollView<GetArrayApiType<typeof postApiFeedbackList>>({
    //     initPageSize: 10,
    //     api: model => postApiFeedbackList({
    //         pageSize: 10,
    //         pageIndex: 1,
    //         finished: true,
    //         system: true,
    //         appId: '3ac003fce2f54fbf',
    //         openId: '13ca2ac66c094ef198d96d4af3ee7618',
    //     }),
    // });
    // 反馈详情
    var toInfo = function toInfo(id) {
      if (!id) return;
      toNext("/feedback/".concat(id));
    };
    var isEmpty = computed(function () {
      return model.finished && list.value.length === 0;
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Activity, {
        "class": "FeedbackView",
        fixed: true
      }, {
        "default": _withCtx(function () {
          return [_unref(isEmpty) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: _unref(avatar) || _unref(default_avatar),
            alt: "",
            "class": _normalizeClass({
              'empty': !_unref(avatar)
            })
          }, null, 10, _hoisted_4), _createElementVNode("p", null, _toDisplayString(_unref(nickname)), 1)])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("p", null, _toDisplayString(_unref(t)('NotSubmittedYet')), 1)])])) : (_openBlock(), _createBlock(_unref(ScreenScrollView), _mergeProps({
            key: 1
          }, _unref(model), {
            list: _unref(list),
            method: _unref(method),
            loading: _unref(loading),
            "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(loading) ? loading.value = $event : null;
            }),
            refreshing: _unref(refreshing),
            "onUpdate:refreshing": _cache[1] || (_cache[1] = function ($event) {
              return _isRef(refreshing) ? refreshing.value = $event : null;
            }),
            error: _unref(error),
            "onUpdate:error": _cache[2] || (_cache[2] = function ($event) {
              return _isRef(error) ? error.value = $event : null;
            })
          }), {
            item: _withCtx(function (_ref) {
              var item = _ref.item,
                index = _ref.index;
              return [index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
                src: _unref(avatar) || _unref(default_avatar),
                alt: "",
                "class": _normalizeClass({
                  'empty': !_unref(avatar)
                })
              }, null, 10, _hoisted_10), _createElementVNode("p", null, _toDisplayString(_unref(nickname)), 1)])]), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('FeedbackList')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
                "class": _normalizeClass(["item", {
                  'lookStatus': Number(item.lookStatus) === 0
                }]),
                onClick: function onClick($event) {
                  return toInfo(item.id);
                }
              }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.content), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.addTime), 1)]), _hoisted_16], 10, _hoisted_12)];
            }),
            _: 1
          }, 16, ["list", "method", "loading", "refreshing", "error"]))];
        }),
        _: 1
      });
    };
  }
});